import { FormLabel, Typography } from '@mui/material'
import { C1FormLabelStyles } from 'components/core/RHKFormComponents/C1FormLabelStyles'
import { ComponentProps, FC, ReactNode } from 'react'

interface C1FormLabelProps extends ComponentProps<typeof FormLabel> {
    label: ReactNode
}
// TODO: atebbs - issues w/ this component:
// 1. C1FormLableStyles.root - margin-bottom doesn't actually apply because
//    FormLabel is a <label>, not a block-level element, also, any custom styles
//    should come via the theme.
// 2. We should just use children rather than label prop
// 3. The inner <Typography> isn't needed. As much as possible, this component should
//    be a thin wrapper around FormLabel.
export const C1FormLabel: FC<C1FormLabelProps> = ({ label, htmlFor, ...rest }) =>
    <FormLabel sx={C1FormLabelStyles.root} id={htmlFor ? `label-${htmlFor}` : undefined} htmlFor={htmlFor} {...rest}>
        <Typography variant="h6" component="span">
            {label}
        </Typography>
    </FormLabel>
